// @ts-nocheck
import { useState } from 'react'

type PaymentType = 'perTeam' | 'perPlayer' | 'noPayment'
type TabType = 'create' | 'select'

interface PaymentSetup {
  _id: string
  name: string
  type: PaymentType,
  amount: number | null
  playerPaySeparately?: boolean
}

export function useLeaguePaymentForm() {
  const [name, setName] = useState('')
  const [type, setType] = useState<PaymentType>('noPayment')
  const [amount, setAmount] = useState<number | null>(null)
  const [playerPaySeparately, setPlayerPaySeparately] = useState(false)
  const [previousPayments, setPreviousPayments] = useState<PaymentSetup[]>([
    { _id: '1', name: 'Season 2022', type: 'perTeam', amount: 500 },
    { _id: '2', name: 'Tournament 2023', type: 'perPlayer', amount: 50 },
    { _id: '3', name: 'Charity Event', type: 'noPayment', amount: null },
  ])
  const [selectedPayment, setSelectedPayment] = useState<PaymentSetup | null>(null)
  const [activeTab, setActiveTab] = useState<TabType>('select')

  const handleSubmit = () => {
    if (type !== 'noPayment' && !amount) {
      alert('Please enter an amount for the payment')
      return
    }

    const newPayment: PaymentSetup = {
      _id: Date.now().toString(),
      name,
      type,
      amount: type === 'noPayment' ? null : amount,
    }

    setPreviousPayments([...previousPayments, newPayment])
    resetForm()
  }

  const resetForm = () => {
    setName('')
    setType('noPayment')
    setAmount(null)
    setPlayerPaySeparately(false)
    setSelectedPayment(null)
    setActiveTab('select')
  }

  return {
    name,
    setName,
    type,
    setType,
    amount,
    setAmount,
    playerPaySeparately,
    setPlayerPaySeparately,
    previousPayments,
    selectedPayment,
    setSelectedPayment,
    activeTab,
    setActiveTab,
    handleSubmit,
    resetForm,
  }
}

